import { FC, useEffect, useState } from "react";
import Button, { BUTTON_VARIANTS } from "components/shared/Button/Button";
import ModalPortal from "components-new/ModalPortal";
import { useFormik } from "formik";
import { addingEmployeeSchema } from "libs/yup/addingEmployeeSchema";
import InputTemp from "components-new/InputTemp";
import styles from "./AddingEmployee.module.sass";
import { InputDate } from "components-new/InputDate/InputDate";
import { useValidate } from "hooks/useValidate";
import {employeeAPI} from "../../libs/apiClient/Employee";

interface AddingEmployeePropsInterface {
	close: () => void;
	orgs: any[];
	params: any;
	archive: any;
}

export const AddingEmployee: FC<AddingEmployeePropsInterface> = ({ close, params }) => {
	const [options, setOptions] = useState<{
		department: any[];
		position: any[];
		relationship: any[];
		status: any[];
	}>({
		department: [],
		position: [],
		relationship: [],
		status: [],
	});

	useEffect(() => {
		employeeAPI.dictionariesList().then((r:any) => {
			const data = r.data;
			setOptions({
				department: Object.values(data.department as string[]).map((_: string, index: number) => ({
					name: _,
					id: index + 1,
				})),
				position: Object.values(data.position as string[]).map((_: string, index: number) => ({
					name: _,
					id: index + 1,
				})),
				relationship: Object.values(data.relationship as string[]).map((_: string, index: number) => ({
					name: _,
					id: index + 1,
				})),
				status: Object.values(data.status as string[]).map((_: string, index: number) => ({ name: _, id: index + 1 })),
			});
		});
	}, []);

	const formik = useFormik<{
		firstName: string;
		lastName: string;
		middleName: string;
		tabNumber: string;
		orgId: { id: number; name: string } | null;
		orgRelationship: { id: number; name: string } | null;
		position: string;
		department: string;
		employmentDate: string;
		dismissalDate: string;
		statusId: { id: number; name: string } | null;
	}>({
		initialValues: {
			firstName: "",
			lastName: "",
			middleName: "",
			tabNumber: "",
			orgId: null,
			orgRelationship: null,
			position: "",
			department: "",
			employmentDate: "",
			dismissalDate: "",
			statusId: null,
		},
		onSubmit: (values) => {
			const { dismissalDate, ...items } = values;
			employeeAPI.employeeCreate({
				...items,
				statusId: values.statusId?.id!,
				position: values.position,
				department: values.department,
				orgRelationship: values.orgRelationship?.id!,
				...(dismissalDate && { dismissalDate }),
				orgId: values.orgId?.id!,
			}).then(() => {
					// if (archive) {
					// 	// @ts-ignore
					// 	dispatch(getAcriveEmployees(params));
					// } else {
					// 	// @ts-ignore
					// 	dispatch(getAllEmployees(params));
					// }
					// close();
				})
				.catch(() => console.log("Не удалось"));
		},
		validationSchema: addingEmployeeSchema,
	});

	const submit = () => {
		const { dismissalDate, ...items } = formik.values;
		employeeAPI.employeeCreate({
			...items,
			statusId: formik.values.statusId?.id!,
			position: formik.values.position,
			department: formik.values.department,
			orgRelationship: formik.values.orgRelationship?.id!,
			...(dismissalDate && { dismissalDate }),
			orgId: formik.values.orgId?.id!,
		}).then(() => {
				params();
				close();
			})
			.catch(() => console.log("Не удалось"));
	};

	const [search, setSearch] = useState("");

	const { error, validate } = useValidate(
		formik.values,
		[
			"orgId",
			"orgRelationship",
			"firstName",
			"middleName",
			"department",
			"employmentDate",
			"lastName",
			"position",
			"statusId",
			"tabNumber",
		],
		submit,
	);
	return (
		<ModalPortal handleClose={close} transparent className={styles.modal} title="Добавить сотрудника" outSide={false}>
			<div>
				<InputTemp
					required={true}
					placeholder={"Введите текст"}
					className={styles.input}
					label="Фамилия"
					value={formik.values.lastName}
					name="lastName"
					onChange={formik.handleChange}
					error={error && !formik.values.lastName.length}
				/>
				<InputTemp
					placeholder={"Введите текст"}
					required={true}
					className={styles.input}
					label="Имя"
					value={formik.values.firstName}
					name="firstName"
					onChange={formik.handleChange}
					error={error && !formik.values.firstName.length}
				/>
				<InputTemp
					required={true}
					className={styles.input}
					placeholder={"Введите текст"}
					label="Отчество"
					value={formik.values.middleName}
					name="middleName"
					onChange={formik.handleChange}
					error={error && !formik.values.middleName.length}
				/>
				<InputTemp
					required={true}
					placeholder={"Введите текст"}
					className={styles.input}
					label="Табельный номер"
					name="tabNumber"
					onChange={formik.handleChange}
					error={error && !formik.values.tabNumber.length}
				/>

				<InputTemp
					required={true}
					className={styles.input}
					onBlur={() => {
						let event;
						if (formik.values.orgId?.name) {
							event = {
								target: { name: "orgId", value: { id: formik.values.orgId?.name, name: formik.values.orgId?.name } },
							};
						} else {
							event = {
								target: { name: "orgId", value: { id: null, name: "" } },
							};
						}
						formik.handleChange(event);
						setSearch(event.target.value.name);
					}}
					placeholder={"Не выбрано"}
					label="Организация-работодатель"
					// filter={true}
					value={search}
					// options={orgs}
					remote={{
						link: "/organizations/all",
						initialParams: { archived: false },
					}}
					field={"shortName"}
					error={error && !formik.values.orgId?.name}
					onChange={({ target }) => setSearch(target.value)}
					onSelect={(e) => {
						let event = {
							target: { name: "orgId", value: { id: e.id, name: e.shortName } },
						};
						formik.handleChange(event);
						setSearch(e.shortName);
					}}
				/>
				<InputTemp
					required={true}
					className={styles.input}
					label="Вид отношений с организацией"
					placeholder={"Не выбрано"}
					options={options.relationship}
					value={formik.values.orgRelationship ? formik.values.orgRelationship.name : ""}
					field={"name"}
					type="select"
					name="orgRelationship"
					error={error && !formik.values.orgRelationship?.name}
					onSelect={(e) => {
						let event = {
							target: {
								name: "orgRelationship",
								value: { name: e.name, id: e.id },
							},
						};
						formik.handleChange(event);
					}}
				/>
				<InputTemp
					required={true}
					className={styles.input}
					options={options.position}
					field={"name"}
					placeholder={"Не выбрано"}
					value={formik.values.position}
					label="Должность"
					isCreated={true}
					filter={true}
					emptyOptions={false}
					onChange={formik.handleChange}
					onSelect={(e) => {
						let event = { target: { name: "position", value: e.name } };
						formik.handleChange(event);
					}}
					error={error && !formik.values.position.length}
					name="position"
				/>
				<InputTemp
					required={true}
					className={styles.input}
					options={options.department}
					field={"name"}
					label="Подразделение"
					isCreated={true}
					placeholder={"Не выбрано"}
					value={formik.values.department}
					filter={true}
					emptyOptions={false}
					onChange={formik.handleChange}
					name="department"
					onSelect={(e) => {
						let event = { target: { name: "department", value: e.name } };
						formik.handleChange(event);
					}}
					error={error && !formik.values.department}
				/>
				<InputTemp
					required={true}
					className={styles.input}
					options={options.status}
					value={formik.values.statusId ? formik.values.statusId.name : ""}
					error={error && !formik.values.statusId?.name}
					placeholder={"Не выбрано"}
					label="Статус"
					onSelect={(e) => {
						let event = {
							target: { name: "statusId", value: { name: e.name, id: e.id } },
						};
						formik.handleChange(event);
					}}
					field={"name"}
					type="select"
					name="statusId"
				/>
				<InputDate
					required={true}
					className={styles.input}
					name="employmentDate"
					value={formik.values.employmentDate}
					title="Дата приема на работу сотрудника"
					onChange={formik.handleChange}
					submitError={error && !formik.values.employmentDate}
					min="2000-01-01"
					max="3000-12-31"
				/>
				<InputDate
					className={styles.input}
					name="dismissalDate"
					value={formik.values.dismissalDate}
					title="Дата увольнения сотрудника"
					onChange={formik.handleChange}
					submitError={!!formik.errors.dismissalDate}
					min="2000-01-01"
					max="3000-12-31"
				/>
				<div className={styles.buttons}>
					<Button full variant={BUTTON_VARIANTS.OUTLINED} className={styles.button} onClick={close}>
						Отменить
					</Button>
					<Button
						full
						type="submit"
						onClick={() => {
							validate();
						}}>
						Готово
					</Button>
				</div>
			</div>
		</ModalPortal>
	);
};
